import { render } from "./np-upload-widget.vue?vue&type=template&id=7fc35ea1&scoped=true"
import script from "./np-upload-widget.vue?vue&type=script&lang=js"
export * from "./np-upload-widget.vue?vue&type=script&lang=js"

import "./np-upload-widget.vue?vue&type=style&index=0&id=7fc35ea1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc35ea1"]])

export default __exports__